import script from "./BancoPreguntasSugerenciasModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BancoPreguntasSugerenciasModal.vue?vue&type=script&lang=ts&setup=true"

import "./BancoPreguntasSugerenciasModal.vue?vue&type=style&index=0&id=31b66d53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b66d53"]])

export default __exports__